import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { environment } from "../../environments/environment";
import { AbstractAdminService } from "../admin/admin.service";
import { AppRoutingModule } from "../app-routing.module";
import { AbstractAuthorizationService } from "../authorization/services/abstractAuthorization.service";
import { CircCommonModule } from "../common/common.module";
import {
  AbstractCirculationsService,
  AbstractPeopleService,
  AbstractUserService
} from "../interfaces";
import { AdminGuard, StepService } from "../services";
import { ServiceDeskGuard } from "../services/servicedesk-guard.service";
import { AbstractSettingsService } from "../settings/abstractSettingsService";
import { AbstractSubstituteService } from "../substitute/substitute.service";
import { GeneralErrorComponent } from "./page-general-error/general-error/general-error.component";
import { PageGeneralErrorComponent } from "./page-general-error/page-general-error.component";
import { PageNotFoundComponent } from "./page-not-found";
import { RootRedirectComponent } from "./root-redirect";

@NgModule({
  declarations: [
    PageNotFoundComponent,
    PageGeneralErrorComponent,
    GeneralErrorComponent,
    RootRedirectComponent
  ],
  imports: [CircCommonModule, AppRoutingModule],
  exports: [AppRoutingModule],
  providers: [
    {
      provide: AbstractAuthorizationService,
      useClass: environment.services.authorization
    },
    {
      provide: AbstractUserService,
      useClass: environment.services.user
    },
    {
      provide: AbstractCirculationsService,
      useClass: environment.services.circulations
    },
    {
      provide: AbstractPeopleService,
      useClass: environment.services.people
    },

    {
      provide: AbstractSettingsService,
      useClass: environment.services.settings
    },
    {
      provide: AbstractSubstituteService,
      useClass: environment.services.substitute
    },
    {
      provide: AbstractAdminService,
      useClass: environment.services.admin
    },
    AdminGuard,
    ServiceDeskGuard,
    StepService
  ]
})
export class ShellModule {}
